import { render } from "./SignInPromo.vue?vue&type=template&id=698bc8ff&scoped=true"
import script from "./SignInPromo.vue?vue&type=script&lang=js"
export * from "./SignInPromo.vue?vue&type=script&lang=js"

import "./SignInPromo.vue?vue&type=style&index=0&id=698bc8ff&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-698bc8ff"

export default script